import { Component, h, Prop } from '@stencil/core';
import { store } from "../../../redux/store";
import { Unsubscribe } from "@stencil/redux";
import { Cart, Success, Translations } from "../../../redux/types";
import { fetchSuccess } from "../../../redux/actions";
import { trans } from "../../../utils/trans";
import {RootState} from "../../../redux/reducers";

@Component({
    tag: 'rentware-checkout-success',
    shadow: true,
})
export class RentwareCheckoutSuccess {
    @Prop({ mutable: true }) cartState: Cart;
    @Prop({ mutable: true }) bookingCompleted: boolean;
    @Prop({ mutable: true }) success: Success;
    @Prop({ mutable: true }) locale: string;
    @Prop({ mutable: true }) translations: Translations;
    @Prop({ mutable: true }) currency: string;
    @Prop({ mutable: true }) currencyPosition: string;
    @Prop() markPaymentAsCompleted;

    unsubscribe!: Unsubscribe;
    fetchSuccess!: typeof fetchSuccess;

    componentWillLoad() {
        this.unsubscribe = store.mapStateToProps(this, (state: RootState ) => {
            return {
                cartState: state.cart,
                success: state.success,
                locale: state.app.locale,
                translations: state.system.translations,
                currency: state.system.currency,
                currencyPosition: state.system.pricing.format.currencyPosition,
            };
        });

        store.mapDispatchToProps(
            this,
            {
                fetchSuccess,
            },
        )
    }

    componentDidLoad() {
        this.fetchSuccess();

        if (!!this.markPaymentAsCompleted) {
            this.markPaymentAsCompleted();
        }
    }

    disconnectedCallback() {
        this.unsubscribe();
    }

    render() {
        if (!this.success) {
            return null;
        }

        return (
            <rentware-checkout-success-template
                success={this.success}
                cartState={this.cartState}
                onOpenBooking={() => window.open(this.success.order.detailsPageUrl, "_blank")}
                bookingReferenceText={trans('checkout.successOrderInfo', this.locale, this.translations)}
                confirmationEmailText={trans('checkout.successDescription', this.locale, this.translations, { email: this.success.customer.email, reference: this.success.order.reference })}
                openBookingText={trans('checkout.successOpenBookingDetails', this.locale, this.translations)}
                thanksText={trans('checkout.successThanks', this.locale, this.translations, { firstName: this.success.customer.firstName })}
            />
        );
    }
}
